import { useEffect, useCallback } from 'react';

import KM from '@ott/utility-km';

import { SUBSCRIPTIONS_EMAIL_KEY } from '../constants';
import { AuthType, MetricsType } from '../types';

import sels from 'sels';

type PropsType = {
  auth?: AuthType;
  metrics: MetricsType;
};

const LSEmail: string = sels.get(SUBSCRIPTIONS_EMAIL_KEY) || '';

const useFormSubmit = (props: PropsType) => {
  const {
    auth,
    metrics: { eventName, KMData, sendEventOnMount },
  } = props;

  const userEmail = auth?.data?.auth ? auth?.data?.email : '';

  const sendSubscribeToKM = useCallback(
    (email?: string) => {
      const eventEmail = LSEmail || email;
      if (eventEmail) {
        KM(eventName, {
          obj: {
            email: eventEmail,
            ...KMData,
          },
        });

        if (!LSEmail) {
          sels.set(SUBSCRIPTIONS_EMAIL_KEY, eventEmail);
        }
      }
    },
    [KMData]
  );

  useEffect(() => {
    if (sendEventOnMount) {
      sendSubscribeToKM();
    }
  }, []);

  return {
    sendSubscribeToKM,
    userEmail,
    LSEmail,
  };
};

export default useFormSubmit;
